import { getAcademicYearRange, normalizeAcademicYear } from "./academicYear";

export function getCurrentAcademicYearNotificationBounds(academicYear) {
	const range = getAcademicYearRange(academicYear);
	return {
		start: range.start.toISOString(),
		end: range.end.toISOString(),
		label: range.label,
	};
}

export function applyCurrentAcademicYearNotificationFilter(
	query,
	academicYear
) {
	const normalized = normalizeAcademicYear(academicYear);
	const { start, end } = getCurrentAcademicYearNotificationBounds(academicYear);

	// Prefer explicit academic_year on the row (e.g. edited video alerts).
	// Legacy notifications without academic_year fall back to created_at in the AY window.
	return query.or(
		`academic_year.eq."${normalized}",and(academic_year.is.null,created_at.gte."${start}",created_at.lte."${end}")`
	);
}
